import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { YearColumns } from "../../../tableColumns/table-columns";
import { holidayYearJson } from "../../../DynamicFormsJson/MastersJSON/holidayYear";
import { getHolidayYear } from "../../../Slice/year.slice";

class HolidayYearTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { yearList, getHolidayYear } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={holidayYearJson.formPath}
                    screenTitle={holidayYearJson.screenTitle}
                    fieldMeta={holidayYearJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={holidayYearJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={holidayYearJson.pdfFileName}
                    excelFileName={holidayYearJson.excelFileName}
                    showAddButton={holidayYearJson.showAddButton}
                    tableColumnsToFilter={holidayYearJson.tableColumnsToFilter}
                    tableColumns={YearColumns}
                    tableData={yearList?.holidayYear}
                    getTableData={getHolidayYear}
                    apiBaseURL={holidayYearJson.apiBaseURL}
                    baseIdColumn={holidayYearJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={"Add Hoiday Year"}
                    showDeleteIcon={true}
                    showViewButtonInTable={true}
                    formPathView={holidayYearJson.formPathView}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    yearList: state.year,
});
const mapDispatchToProps = {
    getHolidayYear,
};
export default connect(mapStateToProps, mapDispatchToProps)(HolidayYearTable);
